import { useState } from 'react';
import {
  Link,
  Typography,
  Box,
  Table,
  TableBody,
  TableContainer,
  Checkbox,
  Stack,
  Grid,
  Select,
  MenuItem,
  Tooltip,
  Switch,
  FormControlLabel,
  Button,
  IconButton,
  TextField,
  styled
} from '@mui/material';
import { ArrowUpwardOutlined, InfoOutlined } from '@mui/icons-material';
import { AiFillEdit } from 'react-icons/ai';
import { filter } from 'lodash';
import { StyledTableRow, StyledTableCell } from '../Global/Styling';
import { UserListHead } from '../../components/_dashboard/user';
import USERLIST from '../../_mocks_/user';

const Input = styled('input')({
  display: 'none'
});

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)'
    }
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#a6ce39'
      }
    }
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200
    })
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box'
  }
}));

// import USERLIST from '../../_mocks_/user';

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

// Another Sorting table into tabbing area
const TABLE_HEAD2 = [
  { id: 'id', label: 'Target Table Column', alignRight: false },
  { id: 'type', label: 'Source File Column', alignRight: false }
];

const FIELDS_LIST = ['Country', 'Cutomer Banking ID', 'DOB', 'Email ID', 'Gender', 'Name'];

const TARGET_TABLE_OPTIONS = [
  'Address',
  'City',
  'Country',
  'CustomerBankingID',
  'EmailId',
  'Gender',
  'Individual',
  'Name',
  'Phone',
  'SSN',
  'State',
  'Zip'
];

const MAPPING_DATA = [
  {
    label: 'Country',
    defaultValue: 'Calendar.Date',
    options: ['Account', 'BarCode', 'Brand', 'Calendar.Date']
  },
  {
    label: 'CustomerBankingID',
    defaultValue: 'ID',
    options: ['Account', 'BarCode', 'Brand', 'ID']
  },
  {
    label: 'DOB',
    defaultValue: 'Person.BirthDate',
    options: ['Account', 'BarCode', 'Brand', 'Person.BirthDate']
  },
  {
    label: 'EmailId',
    defaultValue: 'Identity.Service.Email',
    options: ['Account', 'BarCode', 'Brand', 'Identity.Service.Email']
  },
  {
    label: 'Gender',
    defaultValue: 'Person.Gender',
    options: ['Account', 'BarCode', 'Brand', 'Person.Gender']
  },
  {
    label: 'Name',
    defaultValue: 'Person.FullName',
    options: ['Account', 'BarCode', 'Brand', 'Person.FullName']
  },
  {
    label: 'Phone',
    defaultValue: 'Identity.Service.Phone',
    options: ['Account', 'BarCode', 'Brand', 'Identity.Service.Phone']
  },
  {
    label: 'SSN',
    defaultValue: 'Identitiy.Government.ID',
    options: ['Account', 'BarCode', 'Brand', 'Identitiy.Government.ID']
  },
  {
    label: 'SSN',
    defaultValue: 'Location.State',
    options: ['Account', 'BarCode', 'Brand', 'Location.State']
  },
  {
    label: 'Zip',
    defaultValue: 'Location.PostalCode',
    options: ['Account', 'BarCode', 'Brand', 'Location.PostalCode']
  }
];

function UploadLeadProspectTable() {
  const [changeList1, setChangeList1] = useState('EmailId');
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(USERLIST.map((n) => n.name));
      return;
    }
    setSelected([]);
  };

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), '');

  return (
    <Box className="viewLeadCard">
      <Grid container>
        <Grid item sm={3}>
          <Box
            sx={{
              borderBottom: '1px solid #ccc',
              pt: '0.5rem',
              pr: '1rem',
              mb: '1rem',
              minHeight: '54px'
            }}
          >
            <Grid container alignItems="center">
              <Grid item sm={7}>
                <Typography variant="body2">
                  <strong>File Name</strong>
                </Typography>
              </Grid>
              <Grid item sm={5} position="relative">
                <TextField
                  defaultValue="homeloan"
                  inputProps={{ className: 'textInput textInputTable' }}
                  disabled
                />
                <IconButton sx={{ position: 'absolute', right: '1px', top: '1px' }}>
                  <AiFillEdit size={14} />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ mb: '1rem', display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1">
              <strong>List of Fields</strong>
            </Typography>
            <ArrowUpwardOutlined sx={{ ml: 1 }} />
          </Box>
          <Stack spacing={2}>
            {FIELDS_LIST.map((field) => (
              <Typography key={field} variant="body2">
                {field}
              </Typography>
            ))}
          </Stack>
        </Grid>
        <Grid item sm={9}>
          <Box
            sx={{
              borderBottom: '1px solid #ccc',
              borderLeft: '1px solid #ccc',
              pt: '2px',
              pl: '1rem',
              minHeight: '54px'
            }}
          >
            <Grid container alignItems="center">
              <Grid item xs>
                <Typography variant="body2">
                  <strong>Fields Mapping</strong>
                </Typography>
              </Grid>
              <Grid item xs textAlign="right">
                <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                  <AntSwitch inputProps={{ 'aria-label': 'ant design' }} sx={{ mr: 1 }} />
                  <Typography
                    component="div"
                    sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}
                  >
                    Intelligent mapping
                  </Typography>
                </Box>
                <Typography component="div">
                  <Link to="#" className="f11">
                    What is this?
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{ borderLeft: '1px solid #ccc', pl: '1rem', pt: '1rem' }}
            className="gbleVTabInfo"
          >
            <Box>
              <Typography className="formLabel" mb={1}>
                Select Target Table
              </Typography>
              <Typography
                component="div"
                display="flex"
                alignItems="center"
                mb={2}
                sx={{ width: '300px' }}
              >
                <Select
                  fullWidth
                  inputProps={{ className: 'textInput' }}
                  className="gbleInpt"
                  value={changeList1}
                  onChange={(e) => setChangeList1(e.target.value)}
                >
                  {TARGET_TABLE_OPTIONS.map((opt) => (
                    <MenuItem key={opt} value={opt}>
                      {opt === 'EmailId' ? 'Email Id' : opt}
                    </MenuItem>
                  ))}
                </Select>
              </Typography>
              <Typography className="formLabel" mb={1}>
                Unique Key
              </Typography>
              <Typography
                component="div"
                display="flex"
                alignItems="center"
                mb={2}
                sx={{ width: '332px' }}
              >
                <TextField
                  fullWidth
                  inputProps={{ className: 'textInput' }}
                  defaultValue="Email"
                  disabled
                />
                <Tooltip
                  title={
                    <Box p={2}>
                      <Typography color="inherit" component="div" mb={1}>
                        <b>Don’t see your primary key?</b>
                      </Typography>
                      <Typography className="f12" sx={{ fontWeight: 'normal' }}>
                        Only string, GUID, and integer data types are supported.
                      </Typography>
                    </Box>
                  }
                  placement="right"
                  arrow
                >
                  <InfoOutlined className="fntdarkBlue" sx={{ ml: 1, cursor: 'pointer' }} />
                </Tooltip>
              </Typography>
              <Typography component="div" mb={1} fontWeight="normal" sx={{ color: '#222' }}>
                Review mapped fields
              </Typography>
              <TableContainer sx={{ mb: '1rem' }}>
                <Table border={1} borderColor="#ebedf2">
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD2}
                    rowCount={USERLIST.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {MAPPING_DATA.map((row, idx) => (
                      <StyledTableRow key={idx} hover tabIndex={-1} role="checkbox">
                        <StyledTableCell>{row.label}</StyledTableCell>
                        <StyledTableCell>
                          <Select
                            inputProps={{ className: 'textInput textInputTable' }}
                            className="gbleInpt"
                            defaultValue={row.defaultValue}
                            sx={{ width: '300px !important' }}
                          >
                            {row.options.map((opt) => (
                              <MenuItem key={opt} value={opt}>
                                {opt}
                              </MenuItem>
                            ))}
                          </Select>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box mb={2}>
                <FormControlLabel
                  control={<Checkbox size="small" />}
                  label="Delete Duplicate Data"
                />
              </Box>
              <Box>
                <Button className="mainBtn mainBtnOther mainBtnSec">validate</Button>
                <Button className="mainBtn mainBtnOther mainBtnSec ml-2">Insert</Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
export default UploadLeadProspectTable;
